import {useQuery} from "@tanstack/react-query";
import {getModelColorItems} from "../../api/catalog";
import {useLocation, useParams} from "react-router-dom";
import CatalogList from "./CatalogList";
import {useContext, useEffect, useState} from "react";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import NotFoundPage from "../core/pages/NotFoundPage";

export default function CatalogListByPath() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const [clearCache, setClearCache] = useState(false)

    const location = useLocation()

    const queryData = useParams();

    const {data: modelColorItemsData, status} = useQuery({
        queryKey: [...['catalog', 'list'], [location.pathname], queryData, clearCache],
        queryFn: () => getModelColorItems({
            url: location.pathname
        }, clearCache),
        retry: 2
    })

    useEffect(() => {
        // @ts-ignore
        window.prerenderReady = status !== 'pending';
    }, [status]);

    useEffect(() => {
        if (status === 'pending') {
            dispatch({type: ReducerActionType.LOAD})
        } else {
            dispatch({type: ReducerActionType.SUCCESS})
        }
    }, [status]);

    useEffect(() => {
        dispatch({type: ReducerActionType.SET_PARAM, paramName: 'meta', payload: modelColorItemsData?.meta})
    }, [modelColorItemsData?.meta]);

    const {
        model_color_items: modelColorItems,
        meta,
        category,
        breadcrumbs,
        banners,
        tags,
        super_categories,
        properties
    } = modelColorItemsData || {
        model_color_items: [],
        super_categories: [],
        meta: undefined,
        properties: []
    }

    if(status === 'error'){
        return (<NotFoundPage />);
    }

    return (
        <div>
            <CatalogList modelColorItems={modelColorItems} meta={meta} category={category} breadcrumbs={breadcrumbs}
                          banners={banners} superCategories={super_categories} tags={tags} properties={properties}/>
            {!clearCache && <span className={'text-white pointer px-3 py-1'} onClick={() => {setClearCache(true)}} aria-label={'очистить кеш'}>.</span>}
            {clearCache && <div className={'text-center alert alert-danger mx-5'}><span>Данные без кеша / кеш обновлен</span></div>}
        </div>)
}